export class CronologiaStatoDTO {
    codiceStato: string;
    dataModifica: Date;
    descrizioneStato: string;
    id: string;
    identificativoPratica: string;
    nota: string;
    versione: number
}